import { ReactNode } from "react";
import { useTranslation } from "@/hooks/useTranslation";
import ar from "@/locales/ar.json";
import en from "@/locales/en.json";
import { Locale } from "@/i18n/config";

// Hook only: يستند على TranslationProvider الموجود في layout
export function useI18n() {
  const { locale, setLocale } = useTranslation();
  const lang: Locale = locale;
  const messagesRaw = lang === "ar" ? (ar as any) : (en as any);

  const messages = {
    ...messagesRaw,
    contact: messagesRaw.contact || { email: "", phone: "", address: "", location: "" },
    home: {
      hero: {
        ...(messagesRaw.hero || {}),
        ctaButtonPrimary:
          messagesRaw?.common?.getStarted ||
          messagesRaw?.hero?.ctaButtonPrimary ||
          "Get Started",
      },
    },
    about: {
      ...(messagesRaw.about || {}),
      companyName:
        messagesRaw?.common?.companyName ||
        messagesRaw?.about?.companyName ||
        "",
    },
  };

  return {
    lang,
    setLang: setLocale,
    messages,
  };
}

// مكوّن شكلي لتوافق الواجهات – لا حاجة لتغليف إضافي
export function I18nProvider({ children }: { children: ReactNode }) {
  return <>{children}</>;
}


